<template>
    <div class="about-us">
        <div class="about-us__head">
            {{ getTranslatedText('About Us') }}
        </div>
        <div class="about-us__contents">
            <div class="about-us__contents__content">
                <div class="about-us__contents__content__title">
                    <div class="about-us__contents__content__title__first">
                        {{ getTranslatedText('about-us-1') }}
                    </div>

                    <div class="about-us__contents__content__title__second">
                        {{ getTranslatedText('about-us-2') }}
                    </div>

                    <div class="about-us__contents__content__title__bold">
                        {{ getTranslatedText('about-us-3') }}
                    </div>
                    <div class="about-us__contents__content__title__last">
                        {{ getTranslatedText('about-us-4') }}
                    </div>
                </div>
                <div class="about-us__contents__content__our">
                    <div class="about-us__contents__content__our__left">
                        {{ getTranslatedText('Our vision') }}
                    </div>
                    <div class="about-us__contents__content__our__right">
                        {{ getTranslatedText('our-vision') }}
                    </div>
                </div>
                <div class="about-us__contents__content__our">
                    <div class="about-us__contents__content__our__left">
                        {{ getTranslatedText('Our mission') }}
                    </div>
                    <div class="about-us__contents__content__our__right">
                        {{ getTranslatedText('our-mission') }}
                    </div>
                </div>
                <div class="about-us__contents__content__our">
                    <div class="about-us__contents__content__our__left">
                        {{ getTranslatedText('Our purpose') }}
                    </div>
                    <div class="about-us__contents__content__our__right">
                        {{ getTranslatedText('Always be a catalyst for growth.') }}
                    </div>
                </div>
            </div>
            <div class="about-us__content__bottom">
                <div class="about-us__content__bottom__container">
                    <div class="about-us__content__bottom__title">
                        {{ getTranslatedText('Brand Values') }}
                    </div>
                    <div class="about-us__content__bottom__content">
                        <div class="about-us__content__bottom__content__left">
                            {{ getTranslatedText('Credibility') }}
                        </div>
                        <div class="about-us__content__bottom__content__right">
                            {{ getTranslatedText('brand-value') }}
                        </div>
                    </div>
                    <div class="about-us__content__bottom__content">
                        <div class="about-us__content__bottom__content__left">
                            {{ getTranslatedText('Simplicity') }}
                        </div>
                        <div class="about-us__content__bottom__content__right">
                            {{ getTranslatedText('Simplicity-1') }}
                        </div>
                    </div>
                    <div class="about-us__content__bottom__content">
                        <div class="about-us__content__bottom__content__left">
                            {{ getTranslatedText('Equality') }}
                        </div>
                        <div class="about-us__content__bottom__content__right">
                            {{ getTranslatedText('Equality-1') }}
                        </div>
                    </div>
                    <div class="about-us__content__bottom__content">
                        <div class="about-us__content__bottom__content__left">
                            {{ getTranslatedText('Human centricity') }}
                        </div>
                        <div class="about-us__content__bottom__content__right">
                            {{ getTranslatedText('Human-1') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixin from '@/mixins/language/language-mixin';

export default {
    mixins: [languageMixin],
    components: {
    },
    data() {
        return {
        };
    },
    methods: {
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/about-us.scss" />
